<template>
  <div class="mavon-box">
    <mavonEditor
        ref="mavoneditor"
        :class="mavonClass"
        v-model="editorContent"
        :autofocus= "autofocus"
        :defaultOpen = "defaultOpen"
        :scrollStyle = "scrollStyle"
        :toolbars = "toolbars"
        @imgAdd="imgAdd"
    ></mavonEditor>
  </div>
</template>

<script>
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";

export default {
  name: "markdownEditor",
  data(){
    return{
      editorContent: "",
      autofocus: false,
      defaultOpen: 'edit',
      scrollStyle: true,
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        //header: true, // 标题
        underline: true, // 下划线
        //strikethrough: true, // 中划线
        mark: true, // 标记
        //superscript: true, // 上角标
        //subscript: true, // 下角标
        quote: true, // 引用
        //ol: true, // 有序列表
        //ul: true, // 无序列表
        //link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        //table: true, // 表格
        //fullscreen: true, // 全屏编辑
        //readmodel: true, // 沉浸式阅读
        //htmlcode: true, // 展示html源码
        //help: true, // 帮助
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        //save: true, // 保存（触发events中的save事件）
        //navigation: true, // 导航目录
        //alignleft: true, // 左对齐
        //aligncenter: true, // 居中
        //alignright: true, // 右对齐
        //subfield: true, // 单双栏模式
        preview: true // 预览
     },

    }
  },
  methods:{
      /*
        * position:对应的图片索引
        * $file：对应的图片文件
        * $img2Url方法语法： $img2Url(索引, 替换url)；
        * $img2Url方法作用：会将markdown中使用该索引的位置自动替换为该url;
      */
      async imgAdd(position, $file){ alert($file);
      let formData = new FormData();
      formData.append("files", $file);
      //const res = await fileUpload(formData)
      //if(res){
      //  this.$refs.mavoneditor.$img2Url(position, res[0].file_url);
      //}
    },
    // imgDel(position, $file){
    //    delete this.img_file[position];
    // },
    clear(){
      this.editorContent = ''
    },
    previewing(){
      this.toolbars.preview = true;
    },
    getContent () {
      return this.editorContent;
    },
    setContext(value){
        this.editorContent = value;
    }
  },
  props:{
    mavonClass:{
      type: String,
      default: 'mavon-default'
    }
  },
  components:{
    mavonEditor
  }
}
</script>

<style scoped>
.mavon-default{
  height: 100% !important;
}
.mavon-360{
  height: 360px !important;
}
.v-note-wrapper {
  min-height: 200px;
}
</style>
